import React, { useMemo, useState } from 'react'
import slugs from './mivIconSlugs.json'

const ICON = (slug) => {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
  return `${base}/erp-design-miv/icons/ui-oval/${slug}.svg`
}

/**
 * Função de cada ícone da MIV, inspirada no que as telas do Oikos já fazem
 * (adicionar, excluir, anexo, busca…). O desenho é só da coleção UI Oval.
 */
const PRINCIPAIS = [
  {
    nome: 'Ação',
    itens: [
      ['Adicionar', 'plus'],
      ['Excluir', 'trash-01'],
      ['Editar', 'pencil-01'],
      ['Fechar', 'x-close'],
      ['Voltar', 'arrow-left'],
      ['Confirmar', 'check'],
      ['Atualizar', 'refresh-cw-01'],
      ['Publicar', 'upload-01'],
      ['Novo registro', 'file-plus-01'],
      ['Incluir na lista', 'plus-circle'],
    ],
  },
  {
    nome: 'Arquivo',
    itens: [
      ['Anexo', 'attachment-01'],
      ['Documento', 'file-01'],
      ['Baixar', 'download-01'],
      ['Pasta vazia', 'folder-x'],
    ],
  },
  {
    nome: 'Pessoas e trabalho',
    itens: [
      ['Pessoas', 'users-01'],
      ['Trabalho', 'briefcase-01'],
      ['Registro', 'user-check-01'],
      ['Tarefa', 'clipboard'],
    ],
  },
  {
    nome: 'Status',
    itens: [
      ['Ok', 'check-circle'],
      ['Aviso', 'alert-triangle'],
      ['Erro', 'alert-circle'],
      ['Prioridade', 'alert-octagon'],
      ['Informação', 'info-circle'],
    ],
  },
  {
    nome: 'Financeiro',
    itens: [
      ['Valor', 'currency-dollar'],
      ['Dinheiro', 'coins-01'],
      ['Receita', 'receipt'],
    ],
  },
  {
    nome: 'Navegação',
    itens: [
      ['Busca', 'search-sm'],
      ['Link', 'link-01'],
      ['Abrir', 'link-external-01'],
      ['Ver', 'eye'],
      ['E-mail', 'mail-01'],
    ],
  },
]

function Glyph({ slug, label }) {
  const url = ICON(slug)
  return (
    <span
      className="erp-miv-glyph"
      role="img"
      aria-label={label || slug}
      style={{
        WebkitMaskImage: `url(${url})`,
        maskImage: `url(${url})`,
      }}
    />
  )
}

export default function ErpIconCatalog() {
  const [showAll, setShowAll] = useState(false)
  const [q, setQ] = useState('')
  const [letter, setLetter] = useState('a')
  const query = q.trim().toLowerCase()

  const letters = useMemo(() => {
    const set = new Set(slugs.map((slug) => slug[0]))
    return [...set].sort()
  }, [])

  const visible = useMemo(() => {
    if (query) return slugs.filter((slug) => slug.includes(query))
    return slugs.filter((slug) => slug.startsWith(letter))
  }, [letter, query])

  return (
    <div className="erp-icon-cat">
      <p className="small text-muted">
        Coleção UI Oval, o download indicado na iconografia da MIV. A função de cada ícone principal segue o uso das telas do Oikos hoje.
      </p>
      {PRINCIPAIS.map((g) => (
        <section key={g.nome}>
          <h3>{g.nome}</h3>
          <ul>
            {g.itens.map(([label, slug]) => (
              <li key={slug}>
                <Glyph slug={slug} label={label} />
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </section>
      ))}
      <button type="button" className="erp-icon-cat__more" onClick={() => setShowAll((v) => !v)}>
        {showAll ? 'Ocultar os outros ícones da MIV' : `Ver os outros ícones da MIV (${slugs.length})`}
      </button>
      {showAll && (
        <div className="erp-icon-cat__all">
          <input
            className="erp-mock-input erp-demo-control"
            value={q}
            placeholder="Buscar na coleção UI Oval"
            onChange={(e) => setQ(e.target.value)}
          />
          {!query && (
            <div className="erp-icon-cat__styles">
              {letters.map((ch) => (
                <button
                  key={ch}
                  type="button"
                  className={ch === letter ? 'is-on' : ''}
                  onClick={() => setLetter(ch)}
                >
                  {ch.toUpperCase()}
                </button>
              ))}
            </div>
          )}
          <p className="small text-muted">{visible.length} ícones</p>
          <ul>
            {visible.map((slug) => (
              <li key={slug}>
                <Glyph slug={slug} label={slug} />
                <span>{slug}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
